import _window from "@src/libraries/window";
import Vue from "@src/libraries/vue";
import { login } from "@src/assets/js/login";
import { isIOS } from "@src/assets/js/device";
import facebookSVG from "@src/assets/images/icons/facebook_logo_invert.svg";
import googleSVG from "@src/assets/images/icons/google_logo.svg";
import appleSVG from "@src/assets/images/icons/apple_logo.svg";
import cordovaStore from "@src/store/cordova";
import localesStore from "@src/store/locales";
import usersStore from "@src/store/users";
export default Vue.extend({
    name: "LoginButtons",
    data() {
        const data = {
            facebookBackground: `background-image:url('${facebookSVG}')`,
            googleBackground: `background-image:url('${googleSVG}')`,
            appleBackground: `background-image:url('${appleSVG}')`,
        };
        return data;
    },
    computed: {
        cordova: () => cordovaStore.cordova,
        lang: () => localesStore.lang,
        loading: () => usersStore.loading,
        me: () => usersStore.me,
        ios() {
            const platformId = window.cordova && window.cordova.platformId;
            const devicePlatform = _window.device && _window.device.platform && _window.device.platform.toLowerCase();
            return isIOS || "ios" == platformId || "ios" == devicePlatform;
        },
        appleLogin() {
            const cordova = this.cordova;
            const lang = this.lang;
            const ios = this.ios;
            if (!cordova)
                return false;
            if (!ios)
                return false;
            if ("en" != lang)
                return false;
            return true;
        },
    },
    methods: {
        login,
        async loginCordovaApple() {
            usersStore.loading = "Login with Apple...";
            await usersStore.loginCordovaApple();
            usersStore.loading = "";
        },
    },
});
